export function SubmitButton({ loading }) {
  return (
    <button
      type="submit"
      className={
        "c-profile__submit c-btn u-tap-size " + (loading ? "is-disabled" : "")
      }
    >
      <span>{loading ? "Guardando..." : "Guardar cambios"}</span>
    </button>
  );
}
